ServiceController.$inject = ['$rootScope', 'ServiceService', '$stateParams', 'AppService', '$uibModal', '$state', '$transitions']

export default function ServiceController($rootScope, ServiceService, $stateParams, AppService, $uibModal, $state, $transitions) {
  var vm = this

  function saveSelection() {
    if (window.getSelection) {
      sel = window.getSelection()
      if (sel.getRangeAt && sel.rangeCount) {
        var ranges = []
        for (var i = 0, len = sel.rangeCount; i < len; ++i) {
          ranges.push(sel.getRangeAt(i))
        }
        return ranges
      }
    } else if (document.selection && document.selection.createRange) {
      return document.selection.createRange()
    }
    return null
  }

  var copy
  $rootScope.$watch('profile.id', profileId => {
    if (profileId !== undefined) {
      ServiceService.getService(profileId, $stateParams.slug).then(res => {
        vm.service = res.data
        copy = angular.copy(vm.service)
      })
    }
  })

  vm.insertLink = function() {
    AppService.savedSel = saveSelection()

    $uibModal.open({
      controller: 'ModalLinkController',
      controllerAs: 'modalLink',
      template: require('../../app/link-modal-new.html')
    }).result.then(angular.noop, angular.noop)
  }
  vm.setPromoted = function() {
    vm.service.isPromoted = !vm.service.isPromoted
  }
  vm.setPublished = function() {
    vm.service.isPublished = !vm.service.isPublished
  }
  vm.delete = function() {
    vm.confirmDelete = true
  }
  vm.doDelete = function() {
    vm.hideAlert('confirmDelete')
    ServiceService.deleteService(vm.service).then(() => $state.go('shell.services'))
  }
  vm.hideAlert = function(alert) {
    vm[alert] = false
  }
  $transitions.onBefore({}, () => {
    if (!angular.equals(vm.service, copy)) return ServiceService.putService(vm.service)
  }, {invokeLimit: 1})
}